var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoryAll(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1305_8081)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 51.9483C40.8071 51.9483 52 40.767 52 26.9742C52 13.1813 40.8071 2 27 2C13.1929 2 2 13.1813 2 26.9742C2 40.767 13.1929 51.9483 27 51.9483Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6677 32.5994C28.6331 32.5994 27.6651 31.9424 27.0591 31.4109C26.4531 31.9424 25.485 32.5994 24.4505 32.5994C22.6843 32.5994 21.8566 30.7612 21.8197 30.68C21.6571 30.3035 21.8197 29.868 22.1965 29.7056C22.566 29.5432 23.002 29.7056 23.172 30.0821C23.1868 30.1042 23.6597 31.123 24.4505 31.123C24.9456 31.123 25.6402 30.7391 26.3053 30.0968C26.7265 29.6908 27.3842 29.6908 27.8055 30.0968C28.4706 30.7391 29.1652 31.123 29.6677 31.123C30.4289 31.123 30.7984 30.1411 30.7984 30.1337C30.9388 29.7499 31.36 29.5579 31.7443 29.6908C32.1285 29.8311 32.3281 30.2445 32.1877 30.6284C31.929 31.3592 31.1087 32.5994 29.6603 32.5994H29.6677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6369 27.6755C39.5482 27.6755 39.4522 27.6607 39.3635 27.6238L33.8728 25.4608C33.592 25.3501 33.4072 25.0769 33.4072 24.7743C33.4072 24.4716 33.592 24.1984 33.8728 24.0877L39.3635 21.9247C39.7477 21.7771 40.1764 21.9616 40.3242 22.3381C40.472 22.7146 40.2872 23.1428 39.9103 23.2978L36.1563 24.7743L39.9103 26.2507C40.2872 26.3984 40.4794 26.8265 40.3242 27.2104C40.2059 27.4983 39.9325 27.6755 39.6369 27.6755Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3555 27.6755C14.0599 27.6755 13.7791 27.4983 13.6682 27.2104C13.5204 26.8339 13.7052 26.4057 14.0821 26.2507L17.8361 24.7742L14.0821 23.2978C13.7052 23.1501 13.513 22.722 13.6682 22.3381C13.8234 21.9542 14.2446 21.7697 14.6289 21.9247L20.1196 24.0877C20.4004 24.1984 20.5852 24.4716 20.5852 24.7742C20.5852 25.0769 20.4004 25.3501 20.1196 25.4608L14.6289 27.6238C14.5402 27.6607 14.4516 27.6755 14.3555 27.6755Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1305_8081",
    x: 0,
    y: 0,
    width: 54,
    height: 53.9484,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1305_8081"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1305_8081",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryAll);
export default __webpack_public_path__ + "static/media/category_all.4a600cca0fa3cbd7d1358a3a9c398e5c.svg";
export { ForwardRef as ReactComponent };